import { useState } from 'react';
import { PageHero } from '../components/UI';
import { WHATSAPP_URL, WHATSAPP_URL_VISIT, EMAIL, PHONE, PHONE_VISIT, ADDRESS, HOURS } from '../data/siteData';

const Ic = ({ d, className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d={d} />
  </svg>
);

const WaIcon = () => (
  <svg className="w-5 h-5 fill-white" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/>
  </svg>
);

const contactItems = [
  { Icon: () => <Ic d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z" />, label: 'Main Consultations', value: PHONE, href: `tel:03084715628` },
  { Icon: () => <Ic d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z" />, label: 'Visit Visa Enquiries', value: PHONE_VISIT, href: `tel:03210784000` },
  { Icon: () => <svg className="w-5 h-5 fill-white" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/></svg>, label: 'WhatsApp', value: PHONE + ' (Chat Now)', href: WHATSAPP_URL, wa: true },
  { Icon: () => <Ic d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />, label: 'Email', value: EMAIL, href: `mailto:${EMAIL}` },
  { Icon: () => <Ic d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z" />, label: 'Office', value: ADDRESS, href: null },
  { Icon: () => <Ic d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />, label: 'Business Hours', value: HOURS, href: null },
];

const services = ['Study Abroad','University Admissions','Visa Assistance','Skilled Migration','Digital Nomad Visa','Visit Visa','Scholarship Guidance','Accommodation','Insurance','Other'];
const destinations = ['United Kingdom','Canada','Australia','United States','Germany','France','Sweden','Finland','Italy','Austria','Netherlands','Other Europe','UAE','Singapore','Malaysia','New Zealand','Not Sure Yet'];

export default function Contact() {
  const [form, setForm] = useState({ firstName:'', lastName:'', email:'', phone:'', service:'', destination:'', message:'' });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const handleSubmit = e => { e.preventDefault(); setSubmitted(true); };

  return (
    <div>
      <PageHero
        breadcrumb="Contact Us"
        title="Let's Start Your Journey"
        subtitle="Book your free consultation — in-person at Gulberg-3 or via WhatsApp. No pressure, no commitment."
      />

      <section className="py-16 bg-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">

            {/* ── LEFT PANEL ── */}
            <div className="lg:col-span-2">
              <span className="section-tag">Get In Touch</span>
              <h2 className="font-display text-3xl text-navy font-semibold mt-1 mb-3">We're Ready to Help</h2>
              <p className="text-gray-500 text-sm leading-relaxed mb-7">Walk in, WhatsApp, or call. Whatever works for you. The first consultation is always free.</p>

              <div className="flex flex-col gap-4 mb-7">
                {contactItems.map(({ Icon, label, value, href, wa }) => (
                  <div key={label} className="flex gap-3.5 items-start">
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${wa ? 'bg-[#25D366]' : 'bg-teal/8'}`}>
                      <div className={wa ? 'text-white' : 'text-teal'}>
                        <Icon />
                      </div>
                    </div>
                    <div>
                      <strong className="block text-navy text-xs font-semibold mb-0.5">{label}</strong>
                      {href
                        ? <a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel="noreferrer" className="text-gray-500 text-sm hover:text-teal transition-colors">{value}</a>
                        : <span className="text-gray-500 text-sm">{value}</span>
                      }
                    </div>
                  </div>
                ))}
              </div>

              <a href={WHATSAPP_URL} target="_blank" rel="noreferrer"
                className="w-full flex items-center justify-center gap-2 bg-[#25D366] text-white font-semibold text-sm px-6 py-3.5 rounded-xl hover:bg-green-500 transition-colors shadow-[0_4px_14px_rgba(37,211,102,0.35)] mb-5">
                <WaIcon />
                Chat on WhatsApp Now
              </a>

              {/* Map placeholder */}
              <div className="h-44 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl flex flex-col items-center justify-center gap-2 border border-gray-200">
                <div className="w-10 h-10 rounded-full bg-teal/15 flex items-center justify-center">
                  <Ic d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z" className="w-5 h-5 text-teal" />
                </div>
                <p className="text-gray-600 text-sm font-medium text-center px-4 leading-snug">{ADDRESS}</p>
                <p className="text-gray-400 text-xs">Visit by appointment</p>
              </div>
            </div>

            {/* ── RIGHT FORM ── */}
            <div className="lg:col-span-3">
              <div className="bg-white border border-gray-100 rounded-3xl p-8 shadow-[0_8px_40px_rgba(11,31,58,0.08)]">
                {submitted ? (
                  <div className="text-center py-12">
                    {/* Success icon */}
                    <div className="w-16 h-16 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center mx-auto mb-5">
                      <svg className="w-8 h-8 text-emerald-500" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                      </svg>
                    </div>
                    <h3 className="font-display text-3xl text-navy font-semibold mb-2">Request Submitted!</h3>
                    <p className="text-gray-500 text-sm max-w-xs mx-auto mb-6">Our counselors will reach out within 2 hours on WhatsApp and email.</p>
                    <div className="flex gap-3 justify-center flex-wrap">
                      <a href={WHATSAPP_URL} target="_blank" rel="noreferrer"
                        className="flex items-center gap-2 bg-[#25D366] text-white font-semibold text-sm px-5 py-3 rounded-xl hover:bg-green-500 transition-colors">
                        <WaIcon /> Chat on WhatsApp
                      </a>
                      <button onClick={() => setSubmitted(false)} className="btn-outline-dark px-5 py-3 text-sm">Submit Another</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="flex items-center gap-3 mb-5">
                      <div className="w-10 h-10 rounded-xl bg-teal/8 flex items-center justify-center">
                        <svg className="w-5 h-5 text-teal" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                        </svg>
                      </div>
                      <div>
                        <h3 className="font-display text-2xl text-navy font-semibold leading-tight">Book Free Consultation</h3>
                        <p className="text-gray-400 text-xs">Response within 2 hours · No obligation</p>
                      </div>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-xs font-semibold text-navy mb-1.5">First Name *</label>
                          <input name="firstName" value={form.firstName} onChange={handleChange} required placeholder="Ahmed" className="form-input" />
                        </div>
                        <div>
                          <label className="block text-xs font-semibold text-navy mb-1.5">Last Name *</label>
                          <input name="lastName" value={form.lastName} onChange={handleChange} required placeholder="Khan" className="form-input" />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-xs font-semibold text-navy mb-1.5">Email *</label>
                          <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="ahmed@email.com" className="form-input" />
                        </div>
                        <div>
                          <label className="block text-xs font-semibold text-navy mb-1.5">Phone / WhatsApp *</label>
                          <input name="phone" value={form.phone} onChange={handleChange} required placeholder="03XX XXXXXXX" className="form-input" />
                        </div>
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-navy mb-1.5">Service Needed</label>
                        <select name="service" value={form.service} onChange={handleChange} className="form-input">
                          <option value="">Select service...</option>
                          {services.map(s => <option key={s}>{s}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-navy mb-1.5">Preferred Destination</label>
                        <select name="destination" value={form.destination} onChange={handleChange} className="form-input">
                          <option value="">Select destination...</option>
                          {destinations.map(d => <option key={d}>{d}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-navy mb-1.5">Tell Us About Your Goals</label>
                        <textarea name="message" value={form.message} onChange={handleChange} rows={3}
                          placeholder="Share your background, goals, and any specific questions..."
                          className="form-input resize-none"></textarea>
                      </div>
                      <button type="submit"
                        className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-teal to-teal-light text-white font-semibold text-sm py-4 rounded-xl hover:-translate-y-0.5 transition-all shadow-[0_4px_14px_rgba(26,122,138,0.4)]">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                        </svg>
                        Submit Consultation Request
                      </button>
                      <p className="text-center text-[0.7rem] text-gray-400">Free consultation · No obligation · Response within 2 hours</p>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
